export interface WebSourceFaviconProps {
  domain: string;
  className: string;
}

export const FAVICON_SERVICE_URL = 'https://www.google.com/s2/favicons';
export const FAVICON_REQUEST_SIZE = 32;
